const { getUrlsTable } = require("./src/app/constants/hosts");
const { getQontoEnvConfig } = require("./src/config/environment");

module.exports = { getUrlsTable, getQontoEnvConfig };
